"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPurchaseOfferMarket__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_offerId",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "_mmrRoot",
                type: "bytes32",
            },
        ],
        name: "acceptPurchaseOffer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_offerId",
                type: "uint256",
            },
        ],
        name: "cancelPurchaseOffer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_deploymentId",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "_planTemplateId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_deposit",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "_limit",
                type: "uint16",
            },
            {
                internalType: "uint256",
                name: "_minimumAcceptHeight",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_expireDate",
                type: "uint256",
            },
        ],
        name: "createPurchaseOffer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class IPurchaseOfferMarket__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.IPurchaseOfferMarket__factory = IPurchaseOfferMarket__factory;
IPurchaseOfferMarket__factory.abi = _abi;
